$(".jsHover").each(function() {
    var div_moving = $(this).find(".cursor")[0];
    const _ = this;
    var movingDiv = {
        mouseXY: {},
        getXYpos: function(elm) {
            x = elm.offsetLeft;
            y = elm.offsetTop;
            elm = elm.offsetParent;
            while(elm != null) {
                x = parseInt(x) + parseInt(elm.offsetLeft);
                y = parseInt(y) + parseInt(elm.offsetTop);
                elm = elm.offsetParent;
            }
            return {'xp':x, 'yp':y};
        },
        getCoords: function(e) {
            var xy_pos = this.getXYpos(_);
            if(navigator.appVersion.indexOf("MSIE") != -1) {
                var standardBody = (document.compatMode == 'CSS1Compat') ? document.documentElement : document.body;
                x = e.clientX + standardBody.scrollLeft;
                y = e.clientY + standardBody.scrollTop;
            }
            else {
                x = e.pageX;
                y = e.pageY;
            }
            x = x - xy_pos['xp'];
            y = y - xy_pos['yp'];
            return {'xp':x, 'yp':y};
        }
    };
    _.addEventListener("mousemove", function(e) {
        div_moving.classList.remove("hide");
        mouseXY = movingDiv.getCoords(e);
        div_moving.style.left = mouseXY.xp + "px";
        div_moving.style.top = mouseXY.yp + "px";
    });
    _.addEventListener('mouseleave', function(e) {
        div_moving.classList.add("hide");
    });
});
